import { MenuItem, Select } from '@mui/material';

type Props = {
  children: unknown;
  value: string | number | null;
  disabled?: boolean;
  onChange: (value: string | number | null) => void;
  nullOption?: string;
  nullOptionDisabled?: boolean;
  className?: string;
};
export function SelectWithNull({
  children,
  value,
  disabled,
  onChange,
  nullOption = 'Select',
  nullOptionDisabled = false,
  ...rest
}: React.PropsWithChildren<Props>) {
  /**
   * We are replacing null into empty string and back to handle nulls properly in React
   * // https://github.com/facebook/react/issues/11417
   */
  function handleOnChange(e) {
    const selectedValue = e.target.value === '' ? null : e.target.value;
    onChange(selectedValue);
  }

  const selectedValue = value === null ? '' : value; // in React null value means uncontrolled component

  return (
    <Select
      {...rest}
      disabled={disabled}
      value={selectedValue}
      onChange={handleOnChange}
      className="w-full bg-white" // remove bg-white when we get rid of legacy styles
    >
      <MenuItem value="" disabled={nullOptionDisabled}>
        {nullOption}
      </MenuItem>
      {children}
    </Select>
  );
}
